import {
    createContext,
    useContext,
    useEffect,
    useState,
    useCallback,
} from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext({ user: null, ready: false });

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [ready, setReady] = useState(false);

    const refresh = useCallback(async () => {
        const token = localStorage.getItem("xv_admin_token");
        if (!token) {
            setUser(null);
            setReady(true);
            return;
        }
        try {
            const { data } = await api.get("/admin/me");
            setUser(data);
        } catch {
            localStorage.removeItem("xv_admin_token");
            setUser(null);
        } finally {
            setReady(true);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = async (email, password) => {
        const { data } = await api.post("/admin/login", { email, password });
        localStorage.setItem("xv_admin_token", data.access_token);
        await refresh();
    };

    const logout = () => {
        localStorage.removeItem("xv_admin_token");
        setUser(null);
    };

    return (
        <AuthCtx.Provider value={{ user, ready, login, logout, refresh }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
